import React, { useContext, useState, useEffect } from "react";
import { Container, Form } from "react-bootstrap";
import Button from "../../../components/ButtonComponent/Button";
import DataTable from "../../../components/DataTableComponent/DataTable";
import TopBar from "../../../components/TopBarComponent/Topbar";
import EditIcon from "../../../assets/images/Icons/pencilIcon.svg";
import AciveIcon from "../../../assets/images/Icons/activeEyeIcon.svg";
import InaciveIcon from "../../../assets/images/Icons/inactiveEyeIcon.svg";
import DeleteIcon from "../../../assets/images/deleteIcon.svg";
import TableBody from "../../../constants/dummyData.json";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import { EmployeeMasterContext } from "../EmployeeMasterView";
import "./employeeMaster.css";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";
const EmployeeMaster = ({ textContent }) => {
  const {
    addEmployee,
    goBack,
    employeeList,
    getEmployeeData,
    editEmployeeDetail,
    showAlert,
    setShowAlert,
    alertMessage,
    deleteEmpDetail,
    logout,
    callGetEmployeeList,
    employeeListData,
    setCurrentPage,
    statusCode,
    currentPage,
    onPageChange,
    pageCount,
    handleSearchPress,
    searchBox,
    setSearchBox,
    employeeExcel,
    downloadEmployeeListExcelPermission,
    spinnerStatus
  } = useContext(EmployeeMasterContext);
  const Content = TableBody.employeeMaster;
  const [status, setStatus] = useState("active");

  // var categorySelectedName;
  // categorySelectedName = employeeList.map((item) => {
  //   return
  // });
  //
  const tableHeader = [
    {
      title: "Full Name",
      prop: "EmployeeName",
      cell: (row) => (
        <div
          className="ertHeaderEvacuation"
          // onClick={() => {
          //   getEmployeeData(row.EmployeeCode);
          // }}
        >
          <div>{row.EmployeeName}</div>
          {/* <span>{row.ContactNo}</span> */}
        </div>
      ),
    },

    { title: "Employee code", prop: "EmployeeCode" },
    { title: "Contact No", prop: "ContactNo" },
    { title: "Category Type", prop: "CategoryName" },
    // {
    //   title: "Category Type",
    //   prop: "name",
    //   cell: (row) => (
    //     <div className="ertHeaderEvacuation"> {row.Category?.name}</div>
    //   ),
    // },
    { title: "Magnetic Card ID", prop: "MagneticId" },
    { title: "Working Unit", prop: "WorkingUnit" },
    { title: "Supervisor No", prop: "SupervisorNumber" },

    {
      prop: "Status",
      cell: (row) => (
        <div className="editable-buttons">
          {row.Status == "A" ? (
            <img
              src={AciveIcon}
              alt="status icon"
               onClick={() => {
            getEmployeeData(row.EmployeeCode);
          }}
            />
          ) : (
            <img
              src={InaciveIcon}
              alt="status icon"
              // onClick={() => {
              //   setStatus("active");
              // }}
            />
          )}
          {row.Status == "A" ? (
            <img
              src={EditIcon}
              alt="Edit icon"
              onClick={() => {
                editEmployeeDetail(row.EmployeeId);
              }}
            />
          ) : (
            <div className="deleteIconInvisible">
              <img src={EditIcon} />
            </div>
          )}
          {row.Status == "A" ? (
            <img
              src={DeleteIcon}
              alt="delete icon"
              onClick={() => {
                deleteEmpDetail(row.EmployeeId);
              }}
            />
          ) : (
            <div className="deleteIconInvisible">
              <img src={DeleteIcon} />
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="master-page">
           {spinnerStatus && (
                <div className="spinner-overlay-vehicle-report">
                  <Spinner size="xl" className="custom-spinner-vehicle-report" />
                </div>
              )}
      <TopBar />
      <Container>
        <div className="heading-row my-3">
          <div className="title-box">
            <img
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={17}
              onClick={() => goBack()}
            />
            <p className="title-name">{textContent.title} </p>
          </div>
          <div className="header-right">
            <Form.Control
              type="search"
              placeholder="&#x1F50E;&#xFE0E;  Employee Code/Name"
              value={searchBox}
              onChange={(e) => setSearchBox(e.target.value)}
              className="me-2 search-bar"
              onKeyDown={(e) => handleSearchPress(e)}
              aria-label="Search"
            />
            <p
              className={
                downloadEmployeeListExcelPermission
                  ? "download-text"
                  : "hidden-download"
              }
            >
              <a
                className={"excel-download"}
                href={
                  employeeExcel ? `${baseURL}/excel/${employeeExcel}` : null
                }
              >
                <img className="excel-icon" src={ExcelIcon} alt="Excel-icon" />
                Download Excel
              </a>
            </p>
            <Button
              text={textContent.buttonText}
              onClick={() => addEmployee()}
            />
          </div>
        </div>
        <DataTable
          tableData={employeeList}
          header={tableHeader}
          isPagination={true}
          onPageChange={(e) => onPageChange(e)}
          currentPage={currentPage}
          pageCount={pageCount}
        />
        <AlertBox
          show={showAlert}
          setShow={setShowAlert}
          alertMessage={alertMessage}
          buttonSubmitText={"OK"}
          handleSubmit={() => {
            if (statusCode == 401) {
              logout();
            } else if (statusCode == 200) {
              callGetEmployeeList(currentPage);
              setShowAlert(false);
            } else {
              setShowAlert(false);
            }
          }}
        />
      </Container>
    </div>
  );
};

export default EmployeeMaster;
